import { useTranslation } from 'react-i18next';

export const useFormStepTranslation = () => {
	return useTranslation(undefined, {
		keyPrefix: 'form-step'
	});
};
